import { render, staticRenderFns } from "./BookingGuestsSummary.vue?vue&type=template&id=42cf0a9c&scoped=true&"
import script from "./BookingGuestsSummary.vue?vue&type=script&lang=js&"
export * from "./BookingGuestsSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42cf0a9c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
